<div appModal [mainClass]="'fix-for-ios'" (closeModal)="close()">
  <section class="modal-title-container">
    <div class="modal--title">{{ title }}</div>
    <div class="modal--subtitle">{{ subtitle }}</div>
  </section>

  <section class="modal-content-container clip-modal__filters">
    <div *ngIf="dropdownData?.event">
      <label class="text-charcoal">Event</label>
      <ng-select
        [items]="dropdownEvents"
        bindLabel="name"
        bindValue="value"
        placeholder="All events"
        (change)="changeEvent($event)"
        [(ngModel)]="selectedEventId"
        (clear)="selectedEventId = 0; selectedGameId = 0"
        [clearable]="selectedEventId"
        [trackByFn]="trackByFn"
        [searchable]="false"
        appendTo="body"
      >
      </ng-select>
    </div>

    <div *ngIf="dropdownData?.game">
      <label class="text-charcoal">Game</label>
      <ng-select
        [items]="dropdownGames"
        bindLabel="name"
        bindValue="value"
        placeholder="All games"
        (change)="changeGame($event)"
        [(ngModel)]="selectedGameId"
        (clear)="selectedGameId = 0"
        [clearable]="selectedGameId"
        [readonly]="!selectedEventId"
        [trackByFn]="trackByFn"
        [searchable]="false"
        appendTo="body"
      >
      </ng-select>
    </div>
    <div *ngIf="dropdownData?.athlete">
      <label class="text-charcoal">Athlete</label>
      <ng-select
        [items]="dropdownAthletes"
        bindLabel="name"
        bindValue="value"
        placeholder="All athletes"
        [(ngModel)]="selectedAthleteId"
        (clear)="selectedAthleteId = 0"
        [clearable]="selectedAthleteId"
        [trackByFn]="trackByFn"
        [searchable]="false"
        appendTo="body"
      >
      </ng-select>
    </div>
  </section>

  <section class="modal-actions-container">
    <button alt="Cancel" class="btn btn-lg btn-grey" (click)="close()">Cancel</button>
    <button alt="Apply Filters" class="btn btn-lg" (click)="applyFilters()">Apply Filters</button>
  </section>
</div>
